import * as types from './actionTypes';

const initialState = {
  registrationSuccess: false,
  registrationError: null,
  sourcePackageId: null,
  administrativeBillingDetailsLoading: false,
  administrativeBillingDetailsError: null,
  administrativeBillingDetailsSuccess: false,
  administrativeBillingDetailsData: null,
  administrativeBillingDetailsDataLoading: false,
  administrativeBillingDetailsDataError: null,
  sendContractOtpLoading: false,
  sendContractOtpError: null,
  sendContractOtpSuccess: false,
  verifyContractOtpLoading: false,
  verifyContractOtpError: null,
  verifyContractOtpSuccess: false,
  contractPdf: null,
  contractLoading: false,
  contractError: null,
  paymentRequiredInfo: null,
  paymentRequiredInfoLoading: false,
  paymentRequiredInfoError: null,
  verifyCheckoutSessionSuccess: null,
  /** From verify-checkout-session `data`: { paid, onboarding_completed } */
  verifyCheckoutSessionData: null,
  verifyCheckoutSessionLoading: false,
  verifyCheckoutSessionError: null,
};

export const merchantRegistrationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_SOURCE_PACKAGE_ID:
      return {
        ...state,
        sourcePackageId: action.payload,
      };
    case types.SUBMIT_MERCHANT_REGISTRATION_SUCCESS:
      return {
        ...state,
        registrationSuccess: true,
        registrationError: null,
        sourcePackageId: null,
      };
    case types.CLEAR_SOURCE_PACKAGE_ID:
      return {
        ...state,
        sourcePackageId: null,
      };
    case types.SUBMIT_MERCHANT_REGISTRATION_FAILURE:
      return {
        ...state,
        registrationError: action.payload,
      };
    case types.SUBMIT_ADMINISTRATIVE_BILLING_DETAILS:
      return {
        ...state,
        administrativeBillingDetailsLoading: true,
        administrativeBillingDetailsError: null,
        administrativeBillingDetailsSuccess: false,
      };
    case types.SUBMIT_ADMINISTRATIVE_BILLING_DETAILS_SUCCESS:
      return {
        ...state,
        administrativeBillingDetailsLoading: false,
        administrativeBillingDetailsError: null,
        administrativeBillingDetailsSuccess: true,
      };
    case types.SUBMIT_ADMINISTRATIVE_BILLING_DETAILS_FAILURE:
      return {
        ...state,
        administrativeBillingDetailsLoading: false,
        administrativeBillingDetailsError: action.payload,
      };
    case types.CLEAR_ADMINISTRATIVE_BILLING_DETAILS_SUCCESS:
      return {
        ...state,
        administrativeBillingDetailsSuccess: false,
      };
    case types.GET_ADMINISTRATIVE_BILLING_DETAILS:
      return {
        ...state,
        administrativeBillingDetailsDataLoading: true,
        administrativeBillingDetailsDataError: null,
      };
    case types.GET_ADMINISTRATIVE_BILLING_DETAILS_SUCCESS:
      return {
        ...state,
        administrativeBillingDetailsDataLoading: false,
        administrativeBillingDetailsDataError: null,
        administrativeBillingDetailsData: action.payload,
      };
    case types.GET_ADMINISTRATIVE_BILLING_DETAILS_FAILURE:
      return {
        ...state,
        administrativeBillingDetailsDataLoading: false,
        administrativeBillingDetailsDataError: action.payload,
        administrativeBillingDetailsData: null,
      };
    case types.CLEAR_MERCHANT_REGISTRATION_ERROR:
      return {
        ...state,
        registrationError: null,
      };
    case types.SEND_CONTRACT_OTP:
      return {
        ...state,
        sendContractOtpLoading: true,
        sendContractOtpError: null,
        sendContractOtpSuccess: false,
      };
    case types.SEND_CONTRACT_OTP_SUCCESS:
      return {
        ...state,
        sendContractOtpLoading: false,
        sendContractOtpError: null,
        sendContractOtpSuccess: true,
      };
    case types.SEND_CONTRACT_OTP_FAILURE:
      return {
        ...state,
        sendContractOtpLoading: false,
        sendContractOtpError: action.payload,
      };
    case types.CLEAR_SEND_CONTRACT_OTP_SUCCESS:
      return {
        ...state,
        sendContractOtpSuccess: false,
      };
    case types.VERIFY_CONTRACT_OTP:
      return {
        ...state,
        verifyContractOtpLoading: true,
        verifyContractOtpError: null,
        verifyContractOtpSuccess: false,
      };
    case types.VERIFY_CONTRACT_OTP_SUCCESS:
      return {
        ...state,
        verifyContractOtpLoading: false,
        verifyContractOtpError: null,
        verifyContractOtpSuccess: true,
      };
    case types.VERIFY_CONTRACT_OTP_FAILURE:
      return {
        ...state,
        verifyContractOtpLoading: false,
        verifyContractOtpError: action.payload,
      };
    case types.CLEAR_VERIFY_CONTRACT_OTP_SUCCESS:
      return {
        ...state,
        verifyContractOtpSuccess: false,
      };
    case types.GET_CONTRACT:
      return {
        ...state,
        contractLoading: true,
        contractError: null,
        contractPdf: null,
      };
    case types.GET_CONTRACT_SUCCESS:
      return {
        ...state,
        contractLoading: false,
        contractError: null,
        contractPdf: action.payload,
      };
    case types.GET_CONTRACT_FAILURE:
      return {
        ...state,
        contractLoading: false,
        contractError: action.payload,
        contractPdf: null,
      };
    case types.GET_MERCHANT_PAYMENT_REQUIRED_INFO:
      return {
        ...state,
        paymentRequiredInfoLoading: true,
        paymentRequiredInfoError: null,
        paymentRequiredInfo: null,
      };
    case types.GET_MERCHANT_PAYMENT_REQUIRED_INFO_SUCCESS:
      return {
        ...state,
        paymentRequiredInfoLoading: false,
        paymentRequiredInfoError: null,
        paymentRequiredInfo: action.payload,
      };
    case types.GET_MERCHANT_PAYMENT_REQUIRED_INFO_FAILURE:
      return {
        ...state,
        paymentRequiredInfoLoading: false,
        paymentRequiredInfoError: action.payload,
        paymentRequiredInfo: null,
      };
    case types.VERIFY_MERCHANT_CHECKOUT_SESSION:
      return {
        ...state,
        verifyCheckoutSessionLoading: true,
        verifyCheckoutSessionError: null,
        verifyCheckoutSessionSuccess: null,
        verifyCheckoutSessionData: null,
      };
    case types.VERIFY_MERCHANT_CHECKOUT_SESSION_SUCCESS:
      return {
        ...state,
        verifyCheckoutSessionLoading: false,
        verifyCheckoutSessionError: null,
        verifyCheckoutSessionSuccess: true,
        verifyCheckoutSessionData: action.payload ?? null,
      };
    case types.VERIFY_MERCHANT_CHECKOUT_SESSION_FAILURE:
      return {
        ...state,
        verifyCheckoutSessionLoading: false,
        verifyCheckoutSessionError: action.payload,
        verifyCheckoutSessionSuccess: false,
        verifyCheckoutSessionData: null,
      };
    case types.CLEAR_MERCHANT_CHECKOUT_VERIFY_SESSION:
      return {
        ...state,
        verifyCheckoutSessionLoading: false,
        verifyCheckoutSessionError: null,
        verifyCheckoutSessionSuccess: null,
        verifyCheckoutSessionData: null,
      };
    default:
      return state;
  }
};
